import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import CheckedOutDueOn from '../CheckedOutDueOn';
import HeldCopiesCount from '../HeldCopiesCount';
import RenewCount from '../RenewCount';
import DueDateNotice from '../DueDateNotice';
import DollarAmount from '../../shared/DollarAmount';
import ItemField from '../../shared/ItemField';

import './CheckedOutSecondaryInfo.scss';

export default function CheckedOutSecondaryInfo({ item }) {
  const heldCopiesCount = item.getIn(['bib', 'availability', 'heldCopies'], 0);
  const isDigital = item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL';
  const renewCount = item.get('timesRenewed', 0);
  const fines = item.get('fines', 0);
  return (
    <div className="cp-checked-out-secondary-info">
      <DueDateNotice
        status={item.get('status')}
        dueDate={item.get('dueDate')} />

      {item.get('dueDate') && (
        <CheckedOutDueOn
          dueDate={item.get('dueDate')}
          isDigital={isDigital} />
      )}

      {heldCopiesCount > 0 && !isDigital && <HeldCopiesCount count={heldCopiesCount} />}

      {renewCount > 0 && <RenewCount count={renewCount} />}

      {fines > 0 && <ItemField
        className="fine-amount"
        name={<FormattedMessage id="fines" />}
        value={<DollarAmount amount={fines} />} /> }
    </div>
  );
}

CheckedOutSecondaryInfo.propTypes = {
  item: ImmutablePropTypes.map
};




// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutSecondaryInfo/CheckedOutSecondaryInfo.jsx